module.exports = { id: "tumblr", url: "/build/app/img/symbols.svg#tumblr", viewBox: "", toString: function() { return this.url; } };